import TariffCollection from '@/classes/TariffCollection';
class Stakeholder {
    type = "stakeholder";
    email;
    tariffs = new TariffCollection();
    constructor(stakeholderJson) {
        this.email = stakeholderJson.email || '';
        this.tariffs.convertFromJson(stakeholderJson.tariffs);
    }
}
export default Stakeholder;
